const imageService = {
  getTransformedSrcSet(image) {
    return (
      `${image['xs']} 1x, ${image['xs_2x']}  2x [(max-width: 599px)] | ` +
      `${image['sm']} 1x, ${image['sm_2x']}  2x [(max-width: 767px)] | ` +
      `${image['md']} 1x, ${image['md_2x']}  2x [(max-width: 1024px)] | ` +
      `${image['lg']} 1x, ${image['lg_2x']}  2x [(max-width: 1292px)] | ` +
      `${image['xl']} 1x, ${image['xl_2x']}  2x [(min-width: 1292px)]`
    );
  }
};

export default imageService;
